import { Grid } from '@mui/material';
import { enqueueSnackbar } from 'notistack';

import { Filter } from 'components/filter';
import { usePedidoCompraContext } from 'context/PedidoCompraContext';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { useFilter } from 'hooks/useFilter';
import {
    PedidoChangeConfigModal,
    PedidoConfigPedidoAutoComplete,
    PedidoGrupoAutoComplete,
    PedidoPrioritarioCheckbox,
    PedidoProdutoTextField,
    PedidoStoreAutoComplete,
} from 'pages/compra/pedido/components';
import { usePedidoFilterContext } from 'pages/compra/pedido/contexts/PedidoFilterContext';
import { useGetAdimplencia, useSearchParamsFilters } from 'pages/compra/pedido/hooks';

export function PedidoCompraListFilter() {
    const { setConfigPedido, setLoja } = usePedidoCompraContext();
    const { handleFilterSubmit, handleFilterReset, setDefaultFilters } = useFilter();
    const { isDownLg } = useBreakpoints();
    const { configPedidoParam, lojaParam } = useSearchParamsFilters();
    const {
        filterConfigPedido,
        filterDsProduto,
        filterCategoria,
        filterLoja,
        filterCdProduto,
        filterPrioritario,
        setFilterCdProduto,
        setFilterConfigPedido,
        setFilterDsProduto,
        setFilterCategoria,
        setFilterLoja,
        setFilterPrioritario,
        setDefaultFilterLoja,
        validateLoja,
        validateConfigPedido,
        validateChangeCarrinho,
        openChangeConfigModal,
        setOpenChangeConfigModal,
    } = usePedidoFilterContext();
    const { data: isAdimplente, isFetching: isFetchingAdimplencia } = useGetAdimplencia();

    const filters = [
        { value: filterLoja, setter: setFilterLoja },
        { value: filterConfigPedido, setter: setFilterConfigPedido },
        { value: filterDsProduto, setter: setFilterDsProduto },
        { value: filterCdProduto, setter: setFilterCdProduto },
        { value: filterCategoria, setter: setFilterCategoria },
        { value: filterPrioritario, setter: setFilterPrioritario },
    ];

    /**
     * Valida se a loja está adimplente.
     */
    const validateAdimplencia = () => {
        if (!isAdimplente) {
            let message = 'Loja selecionada está inadimplente';

            if (isAdimplente === undefined) {
                message = 'Não foi possível validar a adimplência da loja';
            }

            enqueueSnackbar(message, { variant: 'error' });
        }

        return isAdimplente;
    };

    /**
     * Valida e inicia o filtro.
     */
    const startFilter = () => {
        if (!validateLoja() || !validateConfigPedido() || !validateAdimplencia() || !validateChangeCarrinho()) return false;

        handleFilterSubmit({ filters });

        setLoja(filterLoja.value);
        setConfigPedido(filterConfigPedido.value);
    };

    /**
     * Reseta os filtros e define a loja padrão.
     */
    const resetFilter = () => {
        handleFilterReset({ filters });

        setDefaultFilterLoja();
    };

    /**
     * Define os valores iniciais do filtro.
     */
    const setInitialStates = () => {
        if (lojaParam && configPedidoParam) {
            // Ao entrar na tela com os filtros da url e tem a configuração de pedido, define ela como último valor selecionado
            // e faz a request para carregar os dados do carrinho.

            setLoja(lojaParam);
            setConfigPedido(configPedidoParam);
        }
    };

    /**
     * Define os valores iniciais e executa o filtro.
     */
    const initFilter = () => {
        setInitialStates();

        setDefaultFilters({ filters, preventQueryParamsEmptyStart: true });
    };

    return (
        <>
            <PedidoChangeConfigModal open={openChangeConfigModal} setOpen={setOpenChangeConfigModal} filters={filters} />

            <Filter preventOnEnter init={initFilter} reset={resetFilter} submit={startFilter} fixed={isDownLg} loadingSubmit={isFetchingAdimplencia}>
                <Grid size={{ lg: 6 }}>
                    <PedidoStoreAutoComplete />
                </Grid>

                <Grid size={{ lg: 6 }}>
                    <PedidoConfigPedidoAutoComplete />
                </Grid>

                <Grid size={{ lg: 6 }}>
                    <PedidoGrupoAutoComplete />
                </Grid>

                <Grid size={{ lg: 3.8 }}>
                    <PedidoProdutoTextField />
                </Grid>

                <Grid size={{ lg: 2.2 }}>
                    <PedidoPrioritarioCheckbox />
                </Grid>
            </Filter>
        </>
    );
}
